import type { ReactNode } from 'react'
import type { FluentIcon } from '@fluentui/react-icons'
import { ArrowRightRegular } from '@fluentui/react-icons'
import styles from './PanelShell.module.css'

interface PanelShellProps {
  icon: FluentIcon
  title: string
  subtitle: string
  onOpenWorkspace: () => void
  children: ReactNode
}

export function PanelShell({ icon: Icon, title, subtitle, onOpenWorkspace, children }: PanelShellProps) {
  return (
    <div className={styles.root}>
      <div className={styles.inner}>
        <header className={styles.header}>
          <div className={styles.titleRow}>
            <span className={styles.iconWrap}>
              <Icon className={styles.icon} aria-hidden="true" />
            </span>
            <div>
              <h1 className={styles.title}>{title}</h1>
              <p className={styles.subtitle}>{subtitle}</p>
            </div>
          </div>
          <button type="button" className={styles.cta} onClick={onOpenWorkspace}>
            Deschide workspace-ul
            <ArrowRightRegular aria-hidden="true" />
          </button>
        </header>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  )
}
